import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { RuleDraw } from '@/components/generals/rule-draw'
import { useParallax } from '@/hooks/use-parallax'

import { MICRO_FAINT } from '@/constants/type'
import { METHOD } from '@/constants/about'

/** Three panels set off the baseline, each drifting at its own rate. */
const PLACEMENT = [
    'col-span-12 sm:col-span-5',
    'col-span-12 sm:col-start-8 sm:col-span-5 sm:mt-24',
    'col-span-12 sm:col-start-3 sm:col-span-5'
]

export const MethodPanels: FC = (): ReactNode => {
    /* One hook per panel — METHOD has a fixed length, so the order never changes. */
    const driftA = useParallax<HTMLDivElement>(-30)
    const driftB = useParallax<HTMLDivElement>(38)
    const driftC = useParallax<HTMLDivElement>(-16)
    const drifts = [driftA, driftB, driftC]

    return (
        <div className='mt-14 grid grid-cols-12 gap-x-6 gap-y-14 sm:mt-20'>
            {METHOD.map((step, index) => (
                <Reveal key={step.index} delay={index * 0.08} className={PLACEMENT[index]}>
                    <div ref={drifts[index]}>
                        <RuleDraw delay={index * 0.08} />

                        <div className='pt-6'>
                            <div className='flex items-baseline justify-between'>
                                <span className={MICRO_FAINT}>{step.index}</span>

                                <span className={MICRO_FAINT}>Movement</span>
                            </div>

                            <h3
                                className='mt-6 font-serif leading-none tracking-[-0.01em] text-fz-ink'
                                style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)' }}
                            >
                                {step.title}
                            </h3>

                            <p className='mt-5 text-[15px] leading-relaxed text-fz-sub'>
                                {step.body}
                            </p>
                        </div>
                    </div>
                </Reveal>
            ))}
        </div>
    )
}
